import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from 'housecall-ui/dist/DesignSystem/Feedback/Progress/CircularProgress';
import Box from 'housecall-ui/dist/DesignSystem/Layout/Box/Box';

import PayWallActionsLayout from 'components/PayWall/PayWallActionsLayout';
import PayWallAddonsContent from 'components/PayWall/PayWallAddonsContent';
import PayWallDialogTitle from 'components/PayWall/PayWallDialogTitle';
import { navigateToReviewPlanChanges } from 'components/PayWall/Redux/Actions';
import { PayWallFullState } from 'components/PayWall/Redux/Reducer.type';
import { getPaywallSpinnerState } from 'components/PayWall/Redux/Selectors';

import BackButton from './PayWallBackButton';
import CancelButton from './PayWallCancelButton';
import { CIRCULAR_PROGRESS_BUTTON_SIZE, useButtonProgressStyles } from './PayWallDialog';
import { PayWallPlanDurationSwitch } from './PayWallPlanSelectionDialog';
import SubmitButton from './PayWallSubmitButton';

function useReviewPlanChanges() {
  const dispatch = useDispatch();
  return useCallback(
    (planId: number) => {
      dispatch(navigateToReviewPlanChanges(planId));
    },
    [dispatch]
  );
}

type Props = {
  onCancel: () => void;
  onBack: () => void;
};

export default function PayWallAddonsDialog(props: Props): JSX.Element {
  const { onCancel, onBack } = props;

  const classes = useButtonProgressStyles({ circularProgressSize: CIRCULAR_PROGRESS_BUTTON_SIZE });
  const loading = useSelector(getPaywallSpinnerState);
  const selectedPlan = useSelector((state: PayWallFullState) => state.payWall.selectedPlan);
  const reviewPlanChanges = useReviewPlanChanges();

  const submitButton = (
    <Box className={classes.wrapper}>
      <SubmitButton disabled={loading} onClick={() => reviewPlanChanges(selectedPlan.id)}>
        Next
      </SubmitButton>
      {loading && <CircularProgress className={classes.buttonProgress} size={CIRCULAR_PROGRESS_BUTTON_SIZE} />}
    </Box>
  );

  return (
    <>
      <PayWallDialogTitle titleAddon={<PayWallPlanDurationSwitch />}>Configure your plan</PayWallDialogTitle>
      <PayWallAddonsContent isLoading={loading} />
      <PayWallActionsLayout
        submitButton={submitButton}
        cancelButton={<CancelButton onClick={onCancel} />}
        backButton={<BackButton onClick={onBack} />}
      />
    </>
  );
}
